import React, { useState, useEffect } from 'react';
import './Cart.css';
import CartCheckOut from '../../Components/CartCheckOut/CartCheckOut';
import CartList from '../../Components/CartList/CartList';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectCartItems } from '../../Utilities/cartSelectors';

function Cart({ setLoggedIn }) {
    const location = useLocation();
    const { classId } = location.state || {};

    const reduxCart = useSelector(selectCartItems) || [];

    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [mobileCartData, setMobileCartData] = useState(null);
    const [showCheckout, setShowCheckout] = useState(false);

    // Handle responsive detection
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // Decode base64 safely
    const decodeBase64 = (encoded) => {
        try {
            return JSON.parse(atob(encoded));
        } catch {
            try {
                const normalized = encoded.replace(/-/g, '+').replace(/_/g, '/');
                return JSON.parse(decodeURIComponent(escape(atob(normalized))));
            } catch (err) {
                console.error("❌ Base64 decode failed", err);
                return null;
            }
        }
    };

    const isValidCartData = (data) =>
        data &&
        Array.isArray(data.items) &&
        typeof data.totalAmount === "number";

    // Process mobile cart data if available
    const processMobileCartData = () => {
        const params = new URLSearchParams(window.location.search);
        const encoded = params.get("data") || params.get("cartData");
        if (!encoded) return;

        let parsed = decodeBase64(encoded);
        if (!parsed || !isValidCartData(parsed)) return;

        // Save login info
        if (parsed.accessToken) {
            localStorage.setItem("accessToken", parsed.accessToken);
            setLoggedIn(true);
        }

        if (parsed.storedDeviceId)
            localStorage.setItem("deviceId", parsed.storedDeviceId);
        if (parsed.storedUserIp)
            localStorage.setItem("userIp", parsed.storedUserIp);

        // Merge mobile items + redux items
        const merged = [...reduxCart];
        parsed.items.forEach((item) => {
            if (!merged.find((x) => x.id === item.id)) merged.push(item);
        });

        const total = merged.reduce(
            (sum, item) => sum + item.price * (item.quantity || 1),
            0
        );

        const finalCart = {
            ...parsed,
            items: merged,
            totalAmount: total,
        };

        setMobileCartData(finalCart);
        localStorage.setItem("mobileCartData", JSON.stringify(finalCart));

        // Remove query params
        window.history.replaceState({}, "", window.location.pathname);
    };

    useEffect(() => {
        processMobileCartData();
    }, []);

    const activeCart = mobileCartData?.items?.length ? mobileCartData.items : reduxCart;
    const activeTotal =
        mobileCartData?.totalAmount ??
        activeCart.reduce((s, i) => s + i.price * (i.quantity || 1), 0);

    const handleContinueToCheckout = () => {
        setShowCheckout(true);
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
        <div className="cart-container">
            <div className="cart-content">
                {isMobile ? (
                    <>
                        {!showCheckout ? (
                            <>
                                <CartList items={activeCart} />
                                <div style={{ textAlign: "center", marginTop: 20 }}>
                                    <button className="btn btn-success" onClick={handleContinueToCheckout}>
                                        Continue to Checkout
                                    </button>
                                </div>
                            </>
                        ) : (
                            <CartCheckOut items={activeCart} totalAmount={activeTotal} />
                        )}
                    </>
                ) : (
                    <>
                        <CartList items={activeCart} />
                        <CartCheckOut items={activeCart} totalAmount={activeTotal} />
                    </>
                )}
            </div>
        </div>
    );
}

export default Cart;
